function getMaxItems(...args) {
  const lengths = args.map((arg) => (Array.isArray(arg) ? arg.length : 0));
  return Math.max(...lengths);
}

export function getMaxLengthArray(...args) {
  const maxItems = getMaxItems(...args);
  return Array.from({ length: maxItems });
}
